import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGurad } from './Services/authguard/authguard.service';
import { LoginComponent } from './Modules/Components/login/login.component';
import { SplashScreenComponent } from './Modules/Components/splash-screen/splash-screen.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./Modules/Authorized-User/authorized-user.module').then(
        (m) => m.AuthorizedUserModule
      ),
    canActivateChild: [AuthGurad],
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'splash',
    component: SplashScreenComponent,
  },
  {
    path: '**',
    redirectTo: '/splash',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
